import i18next from 'i18next';

i18next.addResources('es_CL', 'SpecialRequirements', {
  specialRequirement: '¿Tienes algún requerimiento especial?',
  textareaPlaceholder: 'Solicita acá.',
  remainingCharacters: 'Quedan {{characters}} caracteres restantes.'
});
